<template>
  <v-container id="cargo-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-card v-bind="$attrs" class="v-card--material pa-3">
          <v-form id="form">
            <v-row>
              <v-col cols="12" md="4">
                <z-address-autofill
                  :label="$i18n.t('Pickup From')"
                  v-model="cargo.src"
                />
              </v-col>
              <v-col cols="12" md="4">
                <z-address-autofill
                  :label="$i18n.t('Deliver At')"
                  v-model="cargo.dst"
                />
              </v-col>
              <v-col cols="12" md="2">
                <z-date-picker
                  :label="$i18n.t('Pickup Date')"
                  v-model="cargo.tentativeDate"
                />
              </v-col>
              <!-- <v-col cols="12" md="1">
                <v-checkbox :label="$i18n.t('Part Load')" v-model="cargo.partLoad" />
              </v-col>
              <v-col cols="12" md="1" v-if="cargo.partLoad">
                <v-text-field type="number" :label="$i18n.t('Weight')" v-model="cargo.weight" />
              </v-col>
              <v-col cols="12" md="1" v-if="!cargo.partLoad">
                <z-vehicle-type-select
                  :label="$i18n.t('Truck Type')"
                  v-model="cargo.vehicleType"
                />
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="cargo.material"
                  :items="materialTypes"
                  item-text="name"
                  item-value="name"
                  :label="$i18n.t('Material Type')"
                />
              </v-col>-->
              <v-col cols="12" md="2">
                <v-btn color="info" @click="estimate()">
                  <h3>{{ $i18n.t("Estimate") }}</h3>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <auth-wizard
      :showAuthWizard="showAuthWizard"
      @showAuthWizardUpdate="showAuthWizardUpdate"
    />
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import AuthWizard from "./AuthWizard";

@Component({
  components: {
    AuthWizard,
  },
})
export default class Tickets extends Vue {
  cargo = {
    client: "",
    src: { country: "", state: "", city: "", addrLine: "" },
    dst: { country: "", state: "", city: "", addrLine: "" },
  };
  id = null;
  showAuthWizard = false;
  wightTypes = [
    { value: "9", name: "Above 28 MT" },
    { value: "16", name: "Above 40 MT" },
    { value: "11", name: "Do Not Know" },
    { value: "1016", name: "Upto 12 MT" },
    { value: "5", name: "Upto 15 MT" },
    { value: "6", name: "Upto 20 MT" },
    { value: "7", name: "Upto 25 MT" },
    { value: "8", name: "Upto 28 MT" },
    { value: "2", name: "Upto 5 MT" },
    { value: "3", name: "Upto 7 MT" },
    { value: "4", name: "Upto 9 MT" },
  ];
  materialTypes = [
    { value: "41", name: "Auto Parts" },
    { value: "45", name: "Bardana jute or plastic" },
    { value: "18", name: "Building Materials" },
    { value: "3", name: "Cement" },
    { value: "4", name: "Chemicals" },
    { value: "16", name: "Coal And Ash" },
    { value: "6", name: "Container" },
    { value: "43", name: "Cotton seed" },
    { value: "5", name: "Electronics Consumer Durables" },
    { value: "7", name: "Fertilizers" },
    { value: "10", name: "Fruits And Vegetables" },
    { value: "11", name: "Furniture And Wood Products" },
    { value: "12", name: "House Hold Goods" },
    { value: "13", name: "Industrial Equipments" },
    { value: "17", name: "Iron sheets or bars or scraps" },
    { value: "24", name: "Liquids in drums" },
    { value: "15", name: "Liquids/Oil" },
    { value: "26", name: "Machinery new or old" },
    { value: "25", name: "Medicals" },
    { value: "46", name: "Metals" },
    { value: "27", name: "Mill Jute Oil" },
    { value: "21", name: "Others" },
    { value: "9", name: "Packed Food" },
    { value: "23", name: "Plastic Pipes or other products" },
    { value: "29", name: "powder bags" },
    { value: "22", name: "Printed books or Paper rolls" },
    { value: "8", name: "Refrigerated Goods" },
    { value: "1", name: "Rice or wheat or Agriculture Products" },
    { value: "14", name: "Scrap" },
    { value: "31", name: "Spices" },
    { value: "19", name: "Textiles" },
    { value: "20", name: "Tyres And Rubber Products" },
    { value: "2", name: "Vehicles or car" },
  ];

  showAuthWizardUpdate(val) {
    this.showAuthWizard = val;
  }

  async getNewCargo(id) {
    try {
      this.cargo = await doGet("/api/cargo/new");
    } catch (e) {
      common.setError(e.message);
    }
  }

  async onRateSelect(rate) {
    if (rate) {
      this.cargo.tariffStructure = rate.tariffStructure;
      this.cargo.vehicleType = rate.tariffStructure.vehicleType;
      common.setLoading(true);
      try {
        this.cargo.fare = await doPost("/api/cargo/calc/fare", this.cargo);
        common.setLoading(false);
      } catch (e) {
        common.setError(e);
        common.setLoading(false);
      }
    }
  }

  async estimate() {
    if (!this.cargo.src || !this.cargo.src.city) {
      common.setError("Please provide source location.");
      return;
    }
    if (!this.cargo.dst || !this.cargo.dst.city) {
      common.setError("Please provide destination location.");
      return;
    }
    if (!this.cargo.tentativeDate) {
      common.setError("Please provide date.");
      return;
    }
    this.showAuthWizard = true;
  }

  async get(id) {
    try {
      this.cargo = await doGet("/api/cargo/" + id + "/detail");
      this.id = this.cargo._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    //this.getNewCargo();
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
